var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _c("div", { staticClass: "sector-edit" }, [
      _c("h1", [_vm._v("Add Sector")]),
      _vm._v(" "),
      _c("div", { staticClass: "sector-edit__wrapper" }, [
        _c(
          "form",
          {
            staticClass: "form",
            attrs: { novalidate: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("ValidationAlert", { attrs: { "error-list": _vm.errors } }),
            _vm._v(" "),
            _c("FormControlSector", {
              attrs: {
                label: "Parent Sector (if applicable)",
                name: "sectors",
                multiple: false,
                "include-ancestors": false,
              },
              model: {
                value: _vm.formData.parent_sector,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "parent_sector", $$v)
                },
                expression: "formData.parent_sector",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sector-edit__new" },
              [
                _c("div", { staticClass: "form__group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.title,
                        expression: "formData.title",
                      },
                      { name: "validate", rawName: "v-validate" },
                    ],
                    staticClass: "form__control",
                    attrs: {
                      id: "name",
                      name: "name",
                      placeholder: "Enter a new name for this sector...",
                      required: "",
                    },
                    domProps: { value: _vm.formData.title },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.formData, "title", $event.target.value)
                        },
                        function ($event) {
                          return _vm.slugify_field(_vm.formData.title)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "form__label", attrs: { for: "name" } },
                    [_vm._v("Name")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__validation" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.slug,
                        expression: "formData.slug",
                      },
                      { name: "validate", rawName: "v-validate" },
                    ],
                    staticClass: "form__control",
                    attrs: {
                      id: "slug",
                      name: "slug",
                      placeholder: "Enter a new slug for this sector...",
                      required: "",
                    },
                    domProps: { value: _vm.formData.slug },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.formData, "slug", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "form__label", attrs: { for: "slug" } },
                    [_vm._v("Slug")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__validation" }),
                ]),
                _vm._v(" "),
                _c("FileUpload", {
                  attrs: {
                    id: "image",
                    label: "Image",
                    name: "image",
                    multiple: false,
                  },
                  model: {
                    value: _vm.formData.image,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "image", $$v)
                    },
                    expression: "formData.image",
                  },
                }),
                _vm._v(" "),
                _c("FormControlUser", {
                  attrs: { name: "leader", label: "Select Sector Leader" },
                  model: {
                    value: _vm.formData.leader_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "leader_id", $$v)
                    },
                    expression: "formData.leader_id",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form__group" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.public,
                          expression: "formData.public",
                        },
                      ],
                      attrs: { id: "public", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.formData.public)
                          ? _vm._i(_vm.formData.public, null) > -1
                          : _vm.formData.public,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.formData.public,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.formData,
                                  "public",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.formData,
                                  "public",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.formData, "public", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "public" } }, [
                      _vm._v("Shown publicly on sector page?"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__group form__group--submit" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: "submit",
                          expression: '"submit"',
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn btn--primary",
                    },
                    [_vm._v("Save & Continue")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }